import { useEffect, useRef, type DependencyList } from "react"

export const useDidUpdate = (effect: () => void, deps: DependencyList) => {
  const isFirst = useRef(true)

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false

      return
    }

    return effect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
